import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { getCatalog, EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { trim } from "@/utils/commonUtil";
// 旧矩阵题检测到版本标记缺失时，一次性补齐本次新增字段
const NEW_JSON_CONFIG_DEFAULTS = {
  crossCellText: "",
  totalFormulaType: false,
  totalFormula: "",
  isResultTypeEnabled: false,
  resultTypeTitle: "",
  resultTypeRuleList: [],
  defaultResultType: "暂无对应类型"
};
let fillInTable = class fillInTable extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.catalogList = [];
    this.editSortDialogKey = Math.random();
    this.formulaSelectionStart = null;
    this.formulaSelectionEnd = null;
    this.formulaTools = [{
      label: "+",
      value: "+"
    }, {
      label: "-",
      value: "-"
    }, {
      label: "×",
      value: "*"
    }, {
      label: "÷",
      value: "/"
    }, {
      label: "(",
      value: "("
    }, {
      label: ")",
      value: ")"
    }];
    this.resultOperatorOptions = [{
      label: "小于",
      value: "LESS_THAN"
    }, {
      label: "小于等于",
      value: "LESS_THAN_OR_EQUAL"
    }, {
      label: "等于",
      value: "EQUAL"
    }, {
      label: "大于等于",
      value: "GREATER_THAN_OR_EQUAL"
    }, {
      label: "大于",
      value: "GREATER_THAN"
    }];
    this.postForm = {
      title: "请填写以下内容",
      itemScore: 0,
      required: 1,
      optionsList: [{
        value: "",
        content: "行标题",
        rightOption: false,
        otherInput: false,
        childList: [{
          value: "",
          content: "行标题1",
          rightOption: false,
          otherInput: false,
          inputMax: undefined,
          subTitle: ""
        }]
      }, {
        value: "",
        content: "列标题",
        rightOption: false,
        otherInput: false,
        childList: [{
          value: "",
          content: "列标题1",
          rightOption: false,
          otherInput: false,
          inputMax: undefined
        }]
      }],
      content: "",
      jsonConfig: {
        subTitle: "",
        showIndex: true,
        isCountTotalNumber: false,
        crossCellText: "",
        totalFormulaType: false,
        totalFormula: "",
        isResultTypeEnabled: false,
        resultTypeTitle: "",
        resultTypeRuleList: [],
        defaultResultType: "暂无对应类型",
        rowList: [],
        columnList: [],
        otherInputForm: "NONE",
        otherInputNumberMin: undefined,
        otherInputNumberMax: undefined,
        otherInputNumberPrecision: 0,
        otherInputMin: undefined,
        otherInputMax: undefined
      }
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      coontent: [{
        required: false,
        type: "string",
        trigger: "blur"
      }],
      itemScore: [{
        required: true,
        message: "请填写题目分值",
        trigger: "blur"
      }],
      rightText: [{
        required: true,
        message: "请填写答案",
        trigger: "blur"
      }],
      scoreRule: [{
        required: true,
        message: "请选择得分规则",
        trigger: "blur"
      }],
      // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
      whetherJoinQuestionBank: [{
        required: true,
        message: "请选择是否加入题库",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      const postForm = JSON.parse(JSON.stringify(this.value));
      this.completeNewJsonConfig(postForm);
      this.postForm = postForm;
      this.formulaSelectionStart = null;
      this.formulaSelectionEnd = null;
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  // 自定义公式仅在对应类型开启时参与校验
  get customFormulaRules() {
    return [{
      required: true,
      validator: this.customFormulaValidator,
      trigger: "blur"
    }];
  }
  // 输出结果类型开启后，标题、规则和默认类型均需要完整校验
  get resultTypeTitleRules() {
    return [{
      required: true,
      message: "请输入标题",
      trigger: "blur"
    }, {
      max: 500,
      message: "标题不能超过500个字",
      trigger: "blur"
    }];
  }
  get resultTypeRuleListRules() {
    return [{
      required: true,
      validator: this.resultTypeRuleListValidator,
      trigger: "change"
    }];
  }
  get defaultResultTypeRules() {
    return [{
      required: true,
      message: "请输入默认类型",
      trigger: "blur"
    }, {
      max: 50,
      message: "默认类型不能超过50个字",
      trigger: "blur"
    }];
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType() {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType
    };
  }
  // 只用 totalFormulaType 作为本次升级的旧数据检测点位
  completeNewJsonConfig(postForm) {
    // 新配置已存在时直接使用，不再逐字段重复检测
    if (!postForm.jsonConfig || Object.prototype.hasOwnProperty.call(postForm.jsonConfig, "totalFormulaType")) {
      return;
    }
    // 旧数据一次性补齐本次新增的 jsonConfig 字段
    Object.assign(postForm.jsonConfig, JSON.parse(JSON.stringify(NEW_JSON_CONFIG_DEFAULTS)));
    // 列最大值属于本次新增字段，需要同步补到每个旧列配置中
    postForm.jsonConfig.columnList.forEach(item => {
      item.inputMax = undefined;
    });
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  // 坐标字母表示行、数字表示列
  getCoordinate(rowIndex, columnIndex) {
    return String.fromCharCode(64 + rowIndex) + columnIndex;
  }
  // 记录输入框失焦前的选区，供快捷输入按原光标位置插入
  saveFormulaSelection() {
    const textarea = this.getFormulaTextarea();
    if (!textarea) {
      return;
    }
    this.formulaSelectionStart = textarea.selectionStart;
    this.formulaSelectionEnd = textarea.selectionEnd;
  }
  // 获取 Element UI 输入框内部的原生 textarea
  getFormulaTextarea() {
    const formulaInput = this.$refs.formulaInput;
    if (!formulaInput || !formulaInput.$el) {
      return null;
    }
    return formulaInput.$el.querySelector("textarea");
  }
  // 快捷符号和坐标插入到失焦前的光标或选区位置
  appendFormulaContent(content) {
    if (this.disabled) {
      return;
    }
    const formula = this.postForm.jsonConfig.totalFormula || "";
    const selectionStart = this.formulaSelectionStart === null ? formula.length : Math.min(this.formulaSelectionStart, formula.length);
    const selectionEnd = this.formulaSelectionEnd === null ? selectionStart : Math.min(Math.max(this.formulaSelectionEnd, selectionStart), formula.length);
    const caretPosition = selectionStart + content.length;
    this.postForm.jsonConfig.totalFormula = formula.slice(0, selectionStart) + content + formula.slice(selectionEnd);
    this.formulaSelectionStart = caretPosition;
    this.formulaSelectionEnd = caretPosition;
    // DOM 更新后恢复焦点和光标，支持连续快捷输入
    this.$nextTick(() => {
      const textarea = this.getFormulaTextarea();
      if (!textarea) {
        return;
      }
      textarea.focus();
      textarea.setSelectionRange(caretPosition, caretPosition);
    });
  }
  // 新增和删除结果规则只改变当前编辑数据
  addResultRule() {
    this.postForm.jsonConfig.resultTypeRuleList.push({
      conditions: [{
        operator: "",
        value: null
      }],
      resultType: ""
    });
  }
  removeResultRule(index) {
    this.postForm.jsonConfig.resultTypeRuleList.splice(index, 1);
  }
  addResultCondition(ruleIndex) {
    const conditions = this.postForm.jsonConfig.resultTypeRuleList[ruleIndex].conditions;
    if (conditions.length === 1) {
      conditions.push({
        operator: "",
        value: null
      });
    }
  }
  removeResultCondition(ruleIndex) {
    this.postForm.jsonConfig.resultTypeRuleList[ruleIndex].conditions.splice(1, 1);
  }
  removeOption(index, type) {
    if (type == "row") {
      this.postForm.jsonConfig.rowList.splice(index, 1);
    } else {
      this.postForm.jsonConfig.columnList.splice(index, 1);
    }
  }
  addOption(type) {
    if (type == "row") {
      this.postForm.jsonConfig.rowList.push({
        value: "",
        content: "",
        rightOption: false,
        otherInput: false,
        inputMax: undefined,
        subTitle: ""
      });
    } else {
      this.postForm.jsonConfig.columnList.push({
        value: "",
        content: "",
        rightOption: false,
        otherInput: false,
        inputMax: undefined,
        subTitle: ""
      });
    }
  }
  optionValidator(rule, value, callback) {
    if (value) {
      const str = trim(value);
      if (str.length == 0) {
        callback(Error("标题不能为空"));
      }
    } else {
      callback(Error("标题不能为空"));
    }
    callback();
  }
  // 中文括号在最终校验前静默转换为英文括号
  normalizeFormula(formula) {
    return (formula || "").replace(/（/g, "(").replace(/）/g, ")");
  }
  // 公式词法分析只接受数字、坐标、四则运算符和括号
  tokenizeFormula(formula) {
    // 第一步：移除空白字符，避免空格和换行影响连续扫描
    const source = formula.replace(/\s/g, "");
    const tokens = [];
    let index = 0;
    // 第二步：游标从左到右识别一个完整 Token，再移动对应长度
    while (index < source.length) {
      const current = source[index];
      const rest = source.slice(index);
      // 数字支持整数、常规小数和省略整数部分的小数
      if (/[0-9.]/.test(current)) {
        const numberMatch = rest.match(/^(?:\d+(?:\.\d+)?|\.\d+)/);
        if (!numberMatch) {
          return {
            tokens: [],
            error: "公式中的数字格式不正确"
          };
        }
        tokens.push({
          type: "NUMBER",
          value: numberMatch[0]
        });
        index += numberMatch[0].length;
        continue;
      }
      // 单元格坐标先识别为大写字母加数字，是否存在留给后续坐标校验
      if (/[A-Z]/.test(current)) {
        const cellMatch = rest.match(/^[A-Z]\d+/);
        if (!cellMatch) {
          return {
            tokens: [],
            error: "公式中的单元格坐标格式不正确"
          };
        }
        tokens.push({
          type: "CELL",
          value: cellMatch[0]
        });
        index += cellMatch[0].length;
        continue;
      }
      // 词法阶段只标记运算符，不在这里判断减号是减法还是负号
      if (/[+\-*/]/.test(current)) {
        tokens.push({
          type: "OPERATOR",
          value: current
        });
        index += 1;
        continue;
      }
      // 左右括号使用不同类型，供语法阶段检查嵌套和配对
      if (current === "(") {
        tokens.push({
          type: "LEFT_PAREN",
          value: current
        });
        index += 1;
        continue;
      }
      if (current === ")") {
        tokens.push({
          type: "RIGHT_PAREN",
          value: current
        });
        index += 1;
        continue;
      }
      // 所有合法类型均未命中时，立即返回当前非法字符
      return {
        tokens: [],
        error: `公式包含不支持的字符：${current}`
      };
    }
    return {
      tokens,
      error: ""
    };
  }
  // 单元格坐标必须使用当前矩阵中真实存在的位置
  validateFormulaCoordinates(tokens) {
    // 以当前行列数量作为坐标有效范围
    const rowCount = this.postForm.jsonConfig.rowList.length;
    const columnCount = this.postForm.jsonConfig.columnList.length;
    for (const token of tokens) {
      // 非坐标 Token 不参与本阶段校验
      if (token.type !== "CELL") {
        continue;
      }
      // 字母转换为行下标，数字转换为从 0 开始的列下标
      const rowIndex = token.value.charCodeAt(0) - 65;
      const columnText = token.value.slice(1);
      const columnIndex = Number(columnText) - 1;
      // 同时拒绝 A01 这类非标准写法和超出当前矩阵范围的坐标
      const isCanonicalCoordinate = columnText === String(columnIndex + 1);
      if (!isCanonicalCoordinate || rowIndex < 0 || rowIndex >= rowCount || columnIndex < 0 || columnIndex >= columnCount) {
        return `公式引用了不存在的单元格：${token.value}`;
      }
    }
    return "";
  }
  // 递归下降解析保证操作数、运算符和括号顺序完整
  validateFormulaSyntax(tokens) {
    let position = 0;
    // 基础值：负号、数字、坐标或一组括号表达式
    const parseFactor = allowUnaryMinus => {
      const token = tokens[position];
      if (!token) {
        return false;
      }
      // 负号只允许出现在整条表达式或括号表达式开头
      if (allowUnaryMinus && token.type === "OPERATOR" && token.value === "-") {
        position += 1;
        return parseFactor(false);
      }
      // 数字和单元格坐标都是完整操作数
      if (token.type === "NUMBER" || token.type === "CELL") {
        position += 1;
        return true;
      }
      // 左括号内递归解析一条完整表达式，并要求当前位置存在右括号
      if (token.type === "LEFT_PAREN") {
        position += 1;
        if (!parseExpression(true)) {
          return false;
        }
        if (!tokens[position] || tokens[position].type !== "RIGHT_PAREN") {
          return false;
        }
        position += 1;
        return true;
      }
      return false;
    };
    // 乘除层：基础值后只允许继续连接乘号或除号和下一个基础值
    const parseTerm = allowUnaryMinus => {
      if (!parseFactor(allowUnaryMinus)) {
        return false;
      }
      while (tokens[position] && tokens[position].type === "OPERATOR" && ["*", "/"].includes(tokens[position].value)) {
        position += 1;
        if (!parseFactor(false)) {
          return false;
        }
      }
      return true;
    };
    // 加减层：乘除表达式后只允许继续连接加号或减号和下一个乘除表达式
    const parseExpression = allowUnaryMinus => {
      if (!parseTerm(allowUnaryMinus)) {
        return false;
      }
      while (tokens[position] && tokens[position].type === "OPERATOR" && ["+", "-"].includes(tokens[position].value)) {
        position += 1;
        if (!parseTerm(false)) {
          return false;
        }
      }
      return true;
    };
    // 必须成功解析且消费完全部 Token，避免遗漏相邻操作数等尾部内容
    return tokens.length > 0 && parseExpression(true) && position === tokens.length;
  }
  // 自定义公式保存校验入口
  customFormulaValidator(rule, value, callback) {
    // 第一步：静默统一中英文括号并回写最终保存值
    const normalizedFormula = this.normalizeFormula(value);
    if (normalizedFormula !== value) {
      this.postForm.jsonConfig.totalFormula = normalizedFormula;
    }
    // 第二步：自定义公式不能为空
    if (!normalizedFormula.trim()) {
      callback(Error("请输入自定义公式"));
      return;
    }
    // 第三步：拆分 Token，并优先反馈非法数字、坐标格式或字符
    const tokenizedFormula = this.tokenizeFormula(normalizedFormula);
    if (tokenizedFormula.error) {
      callback(Error(tokenizedFormula.error));
      return;
    }
    // 第四步：检查公式引用的坐标是否真实存在
    const coordinateError = this.validateFormulaCoordinates(tokenizedFormula.tokens);
    if (coordinateError) {
      callback(Error(coordinateError));
      return;
    }
    // 第五步：检查完整表达式的操作数、运算符和括号顺序
    if (!this.validateFormulaSyntax(tokenizedFormula.tokens)) {
      callback(Error("公式格式不正确，请检查运算符、操作数和括号"));
      return;
    }
    callback();
  }
  // 将单个比较条件转换为数值区间
  conditionToInterval(operator, value) {
    // 默认从无边界区间开始，再根据操作符收紧上界或下界
    const interval = {
      lower: Number.NEGATIVE_INFINITY,
      lowerInclusive: false,
      upper: Number.POSITIVE_INFINITY,
      upperInclusive: false
    };
    // 小于类设置上界，等于设置同值闭区间，大于类设置下界
    if (operator === "LESS_THAN" || operator === "LESS_THAN_OR_EQUAL") {
      interval.upper = value;
      interval.upperInclusive = operator === "LESS_THAN_OR_EQUAL";
    } else if (operator === "EQUAL") {
      interval.lower = value;
      interval.lowerInclusive = true;
      interval.upper = value;
      interval.upperInclusive = true;
    } else {
      interval.lower = value;
      interval.lowerInclusive = operator === "GREATER_THAN_OR_EQUAL";
    }
    return interval;
  }
  // 两个区间求交集，同时处理相等边界的开闭关系
  intersectIntervals(left, right) {
    // 交集下界取较大值；值相同时必须两侧都包含该边界
    let lower = left.lower;
    let lowerInclusive = left.lowerInclusive;
    if (right.lower > lower) {
      lower = right.lower;
      lowerInclusive = right.lowerInclusive;
    } else if (right.lower === lower) {
      lowerInclusive = left.lowerInclusive && right.lowerInclusive;
    }
    // 交集上界取较小值；值相同时必须两侧都包含该边界
    let upper = left.upper;
    let upperInclusive = left.upperInclusive;
    if (right.upper < upper) {
      upper = right.upper;
      upperInclusive = right.upperInclusive;
    } else if (right.upper === upper) {
      upperInclusive = left.upperInclusive && right.upperInclusive;
    }
    // 下界超过上界，或同值边界未同时闭合，表示两个条件无交集
    if (lower > upper || lower === upper && !(lowerInclusive && upperInclusive)) {
      return null;
    }
    return {
      lower,
      lowerInclusive,
      upper,
      upperInclusive
    };
  }
  // 单条结果规则最多由两个“并且”条件组成
  getResultRuleInterval(ruleItem) {
    // 从全数值区间开始，依次与每个条件对应区间求交集
    let interval = {
      lower: Number.NEGATIVE_INFINITY,
      lowerInclusive: false,
      upper: Number.POSITIVE_INFINITY,
      upperInclusive: false
    };
    for (const condition of ruleItem.conditions) {
      // 任意一次求交失败，都表示这条规则永远无法命中
      const conditionInterval = this.conditionToInterval(condition.operator, Number(condition.value));
      const intersection = this.intersectIntervals(interval, conditionInterval);
      if (!intersection) {
        return null;
      }
      interval = intersection;
    }
    return interval;
  }
  // 结果规则需完整，且同一条规则的双条件必须存在有效交集
  resultTypeRuleListValidator(rule, value, callback) {
    // 开启结果类型后至少需要一条规则
    if (!Array.isArray(value) || value.length === 0) {
      callback(Error("请至少添加一条结果规则"));
      return;
    }
    for (let index = 0; index < value.length; index++) {
      const ruleItem = value[index];
      // 每条规则只允许一个基础条件和一个可选“并且”条件
      if (!Array.isArray(ruleItem.conditions) || ruleItem.conditions.length < 1 || ruleItem.conditions.length > 2) {
        callback(Error(`第${index + 1}条规则的判断条件不完整`));
        return;
      }
      // 操作符和比较数值必须完整且为有限数字
      const hasInvalidCondition = ruleItem.conditions.some(condition => !condition.operator || condition.value === null || condition.value === undefined || !Number.isFinite(Number(condition.value)));
      if (hasInvalidCondition) {
        callback(Error(`请完整填写第${index + 1}条规则的判断条件和数值`));
        return;
      }
      // 命中后的输出文案必须满足必填和长度要求
      if (!ruleItem.resultType || !ruleItem.resultType.trim()) {
        callback(Error(`请填写第${index + 1}条规则的输出类型`));
        return;
      }
      if (ruleItem.resultType.length > 50) {
        callback(Error(`第${index + 1}条规则的输出类型不能超过50个字`));
        return;
      }
      // 双条件需要形成非空区间，避免出现大于 5 且小于 3
      if (!this.getResultRuleInterval(ruleItem)) {
        callback(Error(`第${index + 1}条规则的两个条件没有可命中的交集`));
        return;
      }
    }
    callback();
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  remoteMethod(query) {
    this.loading = true;
    getCatalog({
      ...this.basicParams,
      name: query,
      pageSize: 50,
      pageNum: 1
    }).then(res => {
      this.catalogList = res.rows || [];
    }).finally(() => this.loading = false);
  }
  catalogFocus() {
    if (this.catalogList.length === 0) {
      this.remoteMethod();
    }
  }
  openSortDialog() {
    this.$refs.editSortDialog.onShow({
      isBusinessTypeDisable: true,
      formData: {
        businessType: this.questionnaireType
      }
    });
  }
  async validate() {
    if (this.postForm.jsonConfig.isCountTotalNumber && this.postForm.jsonConfig.totalFormulaType) {
      this.postForm.jsonConfig.totalFormula = this.normalizeFormula(this.postForm.jsonConfig.totalFormula);
    }
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], fillInTable.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], fillInTable.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], fillInTable.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], fillInTable.prototype, "watchPostForm", null);
fillInTable = __decorate([Component({
  name: "fillInTable",
  components: {
    questionSettingTemplate,
    EditSortDialog
  }
})], fillInTable);
export default fillInTable;